import { isTalkie } from '../utils/env';
const PROMPT_TIPS_EN = [
  {
    type: 'template',
    name: '📝 template',
    tags: [
      {
        name: 'Vampire',
        prompt:
          '1 boy, solo, vampire, red eyes, pale skin, black hair, long hair, holding red wine, in castle, dark environment, candle, elegant, evil smiling',
        img_url:
          'https://talkie.cdn.minimax.io/public-cdn-s3-us-west-2/talkie-op-img/image/843714146_1730174553175_2038256651_1729762687349_T.png',
      },
      {
        name: 'Werewolf',
        prompt:
          '1 boy, solo, werewolf, black hair, short hair, messy hair, muscular, wolf ears, black tank, jeans, night, outdoors, round moon, in forest, dark background, blue eyes, looking at viewer, smiling',
        img_url:
          'https://talkie.cdn.minimax.io/public-cdn-s3-us-west-2/talkie-op-img/image/123020135_1730174552572_2038256651_1729762689584_T.png',
      },
      {
        name: 'Mafia Boss',
        prompt:
          '1 boy, solo, mafia boss, mature male, muscular, black eyes, black hair, short hair, ultra detailed eyes,sharp focus, wearing black suit, tie, siiting on sofa, looking at viewer, black gloves, crossed legs, handsome boy, best light, light from front',
        img_url:
          'https://talkie.cdn.minimax.io/public-cdn-s3-us-west-2/talkie-op-img/image/63932340_1730175282609_2038256651_1729762689072_T.png',
      },
      {
        name: 'Genies',
        prompt:
          '1girl, solo, pretty girl, white hair, long hair, elf ears, red eyes, elegent dress, green dress, bare shoulders, looking at viewer, in forest, outdoors, sunset',
        img_url:
          'https://talkie.cdn.minimax.io/public-cdn-s3-us-west-2/talkie-op-img/image/198415597_1730174552788_2038256651_1729762692646_T.png',
      },
      {
        name: 'Succubus',
        prompt:
          '1girl, solo, succubus, mature female, red hair, medium hair, curly hair, devil eyes, red eyes, black dress, devil wings, devil horns, succubus tail, looking at viewer, evil smile, closed one eye. dark background, fire, in castle, thigh',
        img_url:
          'https://talkie.cdn.minimax.io/public-cdn-s3-us-west-2/talkie-op-img/image/161400079_1730174553661_2038256651_1729762694758_T.png',
      },
      {
        name: 'Mermaid',
        prompt:
          '1 girl, solo, (mermaid :1.2), fish tail, fish scale, blonde hair, wavy hair, long hair, green eyes, shell bikini, diving, underwater, from below, looking at viewer, laughing, air bubble',
        img_url:
          'https://talkie.cdn.minimax.io/public-cdn-s3-us-west-2/talkie-op-img/image/268083534_1730174553799_2038256651_1729762695853_T.png',
      },
      {
        name: 'Reality',
        prompt:
          '1 girl, solo, pretty girl, medium hair, black hair, pencil skirt, wearing glasses, hand on glasses, looking at viewer, cold face, in office, make up, sharp focus',
        img_url:
          'https://talkie.cdn.minimax.io/public-cdn-s3-us-west-2/talkie-op-img/image/1179700318_1730174552972_2038256651_1729762690996_T.png',
      },
      {
        name: 'Medieval',
        prompt:
          '1 boy, solo, elf prince, blond hair, long hair, green eyes, ultra detailed eyes, elf ears, elegant armor, slim, looking at viewer softly, white skin, in forest, sunshine, sharp focus',
        img_url:
          'https://talkie.cdn.minimax.io/public-cdn-s3-us-west-2/talkie-op-img/image/166523180_1730174552380_2038256651_1729762695135_T.png',
      },
      {
        name: 'Humanoid',
        prompt:
          '1man, solo, metallic body structure, exposed mechanical components, wearing a pristine and futuristic butler uniform , golden short hair, blue eyes, ultra detailed eyes, cyborg body, smiling, looking at viewer, high light',
        img_url:
          'https://talkie.cdn.minimax.io/public-cdn-s3-us-west-2/talkie-op-img/image/1095119881_1730174553388_2038256651_1729762691878_T.png',
      },
      {
        name: 'Bully',
        prompt:
          '1 man, solo, muscular, school uniform, blonde hair, short hair, blue eyes, white shirt, bully, messy hair, evil smile, classroom, fist, sharp focus',
        img_url:
          'https://talkie.cdn.minimax.io/public-cdn-s3-us-west-2/talkie-op-img/image/944783300_1730174554003_2038256651_1729762691033_T.png',
      },
      {
        name: 'Magic and Wizards',
        prompt:
          '1 girl, solo, brown hair, short hair, curly hair, wizard robe,wizard hat, holding wand, magic fire, castle background, outdoors, moon, night, pretty girl, red lips, purple eyes, looking at viewer, mysterious atmosphere',
        img_url:
          'https://talkie.cdn.minimax.io/public-cdn-s3-us-west-2/talkie-op-img/image/341027470_1730174552180_2038256651_1729762695153_T.png',
      },
    ],
  },
  {
    type: 'prompt',
    name: '👤 character',
    tags: [
      {
        name: 'gender',
        tips: ['1 boy', '1 girl', 'Male', 'Female'],
      },
      {
        name: 'skin color',
        tips: ['Yellow skin', 'White skin', 'Black skin', 'Pale skin'],
      },
      {
        name: 'facial features',
        tips: ['slender face', 'round face', 'oval face', 'square face', 'baby face'],
      },
      {
        name: 'hairstyle',
        tips: ['Long hair', 'Short hair', 'Curly hair', 'bald'],
      },
      {
        name: 'figure',
        tips: ['muscular', 'skinny', 'plump', 'fat'],
      },
      {
        name: 'expression',
        tips: ['Smile', 'laughing', 'sleepy', 'thinking'],
      },
      {
        name: 'action',
        tips: ['standing', 'sitting', 'lying', 'on stomach', 'kneeling'],
      },
    ],
  },
  {
    type: 'prompt',
    name: '🌟 apparel',
    tags: [
      {
        name: 'hat',
        tips: ['wizard hat', 'Bowler hat', 'beret', 'Baseball cap', 'Santa hat'],
      },
      {
        name: 'coat',
        tips: ['T-shirt', 'shirt', 'tank', 'sweater'],
      },
      {
        name: 'bottoms',
        tips: ['shorts', 'pants', 'jeans', 'skirt'],
      },
      {
        name: 'shoes',
        tips: ['Bare foot', 'business shoes', 'sneakers', 'Slippers'],
      },
      {
        name: 'ornament',
        tips: ['tie', 'scarf', 'bow', 'earrings'],
      },
      {
        name: 'props',
        tips: ['holding paintbrush', 'holding book', 'holding rose', 'holding gun'],
      },
      {
        name: 'suit',
        tips: ['school uniform', 'wedding dress', 'Nurse uniform', 'Sportswear'],
      },
    ],
  },
  {
    type: 'prompt',
    name: '🏙️ background',
    tags: [
      {
        name: 'place',
        tips: ['city', 'countryside', 'castle', 'amusement_park'],
      },
      {
        name: 'weather',
        tips: ['sunrise', 'day', 'dusk', 'night'],
      },
      {
        name: 'atmosphere',
        tips: ['Spring Festival', 'Christmas', 'Valentine', 'Halloween'],
      },
    ],
  },
  {
    type: 'prompt',
    name: '📷 lenses',
    tags: [
      {
        name: 'Scenery',
        tips: ['close-up', 'mid_shot', 'upper_body', 'bust'],
      },
      {
        name: 'angle',
        tips: ['front view', 'from_side', 'from_back', 'from_above'],
      },
    ],
  },
];

const PROMPT_TIPS_ZH = [
  {
    type: 'template',
    name: '📝 模版',
    tags: [
      {
        name: '霸总',
        prompt:
          '1男人， 单人， 黑帮老大，成熟男性，肌肉发达，黑色眼睛，黑色头发，短头发，极致细节的眼睛，锐利对焦，穿着黑色西装，领带，坐在沙发上，看向观众，黑色手套，二郎腿，帅气男生，最好的灯光，正面灯光',
        img_url:
          'https://filecdn-other.xingyeai.com/xingye_operation/image/1221268638_1730175997275_211169145_1729762290586_.png',
      },
      {
        name: '古风侠客',
        prompt:
          '1男人，单人，中式传统风格，白色汉服，长发，黑发，帅气男生，竹林，拿着剑，锐利对焦，最好的灯光，坐，看向观众',
        img_url:
          'https://filecdn-other.xingyeai.com/xingye_operation/image/495888416_1730175996116_211169145_1729762290931_.png',
      },
      {
        name: '狐妖少女',
        prompt:
          '1女孩，单人， 粉色头发，长头发，旗袍，狐狸头发，粉色眼睛，狐狸尾巴，看向观众，漂亮女孩，最好的灯光，脸红，微笑',
        img_url:
          'https://filecdn-other.xingyeai.com/xingye_operation/image/622156290_1730175995476_211169145_1729762292606_.png',
      },
      {
        name: '白发精灵',
        prompt:
          '1女孩，单人，漂亮女孩，白色头发，长发，精灵耳朵，红色眼睛，优雅的长裙，绿色长裙，肩膀裸露，看向观众，树林中，室外，落日',
        img_url:
          'https://filecdn-other.xingyeai.com/xingye_operation/image/595586224_1730175995815_211169145_1729762291599_.png',
      },
      {
        name: '汉服女',
        prompt:
          '1女孩，单人，漂亮女孩，中式传统风格，黑色头发，长发，黑色眼睛，中式头饰，化妆，白色汉服，汉服裙，看向观众，微笑，室内，中式传统建筑，最好的灯光，锐利对焦',
        img_url:
          'https://filecdn-other.xingyeai.com/xingye_operation/image/1402815656_1730175998338_211169145_1729762288036_.png',
      },
      {
        name: '猫娘女仆',
        prompt:
          '1女孩，单人，漂亮女孩，猫女，白色头发，短发，黄色眼睛，女仆装，黑色丝袜，猫尾，看向观众，微笑，可爱，咖啡店里，室内，最好的灯光，锐利对焦',
        img_url:
          'https://filecdn-other.xingyeai.com/xingye_operation/image/1801279366_1730175995464_211169145_1729762290188_.png',
      },
      {
        name: '柔情学妹',
        prompt:
          '1女孩，单人，漂亮女孩，黑色头发，长发，直发，校服，短裙，白色过膝袜，看向观众，笑，拿着书，在教室，锐利对焦',
        img_url:
          'https://filecdn-other.xingyeai.com/xingye_operation/image/1238232476_1730175995527_211169145_1729762293655_.png',
      },
      {
        name: '机车男孩',
        prompt:
          '1男孩，单人，摩托车，白色头发，短发，墨镜，黑色皮夹克，健壮的，白色背心，骑摩托，动态视角，帅气男生',
        img_url:
          'https://filecdn-other.xingyeai.com/xingye_operation/image/1873195457_1730175998105_211169145_1729762285869_.png',
      },
      {
        name: '足球小将',
        prompt:
          '1男人，单人，短发，金发，足球运动员，足球制服，踢足球，蓝色眼睛，奔跑，操场上，汗水，健壮的，英俊男孩，运动头带',
        img_url:
          'https://filecdn-other.xingyeai.com/xingye_operation/image/2121304414_1730175996772_211169145_1729762295221_.png',
      },
      {
        name: '美人鱼',
        prompt:
          '1女孩，单人，(美人鱼 :1.2)， 鱼尾，鱼鳞，金发，波浪发，长发，绿眼，贝壳比基尼，潜水，水下，仰拍，看向观众，大笑，泡泡',
        img_url:
          'https://filecdn-other.xingyeai.com/xingye_operation/image/1330941217_1730175997790_211169145_1729762296091_.png',
      },
      {
        name: '职场ol',
        prompt:
          '1女孩，单人，漂亮女孩，中发，黑发，铅笔裙，戴眼镜，手在眼镜上，看向观众，冷脸，办公室中，化妆，锐利对焦',
        img_url:
          'https://filecdn-other.xingyeai.com/xingye_operation/image/1960516588_1730175997007_211169145_1729762291636_.png',
      },
      {
        name: '邻家姐姐',
        prompt:
          '1女孩，校园美人，美女，单人，褐色头发，长发，温暖微笑，戴眼镜，常服，站在庭院中，草帽，看向观众，庭院',
        img_url:
          'https://filecdn-other.xingyeai.com/xingye_operation/image/11166206_1730175996500_211169145_1729762293322_.png',
      },
      {
        name: '摄政王',
        prompt:
          '1男人，中式传统风格，帅气亲王，丹凤眼，棱角分明的下颚线，高颧骨，雕塑般的鼻子，清晰的眉毛，自信的微笑，深色短发，皇室礼服，冰冷的表情，室内的宫殿场景，戏剧灯光',
        img_url:
          'https://filecdn-other.xingyeai.com/xingye_operation/image/736497280_1730175995468_211169145_1729762286338_.png',
      },
      {
        name: '甜宠男主',
        prompt:
          '1男孩，单人，黑色西装，美丽眼睛，长睫毛，清晰， 精致建模，速写红唇，锁骨，项链，乱发，蓬松的头发，压抑的氛围，精美的脸部特征，多愁善感的眼神，黑色短发',
        img_url:
          'https://filecdn-other.xingyeai.com/xingye_operation/image/904648634_1730175997507_211169145_1729762287255_.png',
      },
      {
        name: '仿生人',
        prompt:
          '1男人，单人，金属身体结构，裸露的机械部件，穿着崭新而具有未来感的管家制服，金色短发，蓝色眼睛，超精细的眼睛，机器人身体，微笑，看着观众，高光',
        img_url:
          'https://filecdn-other.xingyeai.com/xingye_operation/image/247509101_1730175995471_211169145_1729762290162_.png',
      },
    ],
  },
  {
    type: 'prompt',
    name: '👤 角色',
    tags: [
      {
        name: '形象',
        tips: ['1个男孩', '1个女孩', '男性', '女性'],
      },
      {
        name: '肤色',
        tips: ['黄皮肤', '白皮肤', '黑皮肤', '苍白皮肤'],
      },
      {
        name: '五官',
        tips: ['瘦长脸', '圆脸', '鹅蛋脸', '方脸'],
      },
      {
        name: '发型',
        tips: ['长发', '短发', '卷发', '光头'],
      },
      {
        name: '身材',
        tips: ['健壮的', '骨感', '丰满', '肥胖'],
      },
      {
        name: '表情',
        tips: ['微笑', '大笑', '困乏', '思考'],
      },
      {
        name: '动作',
        tips: ['站立', '坐着', '躺着', '趴着'],
      },
    ],
  },
  {
    type: 'prompt',
    name: '🌟 服饰',
    tags: [
      {
        name: '帽子',
        tips: ['巫师帽', '礼帽', '贝雷帽', '棒球帽', '圣诞帽'],
      },
      {
        name: '上衣',
        tips: ['T恤', '衬衫', '背心', '毛衣'],
      },
      {
        name: '下装',
        tips: ['短裤', '长裤', '牛仔裤', '裙子'],
      },
      {
        name: '鞋子',
        tips: ['赤脚', '皮鞋', '运动鞋', '拖鞋'],
      },
      {
        name: '饰品',
        tips: ['领带', '围巾', '蝴蝶结', '耳环'],
      },
      {
        name: '道具',
        tips: ['拿着画笔', '拿着书', '拿着玫瑰', '拿着枪'],
      },
      {
        name: '套装',
        tips: ['校服', '婚纱', '护士服', '运动服'],
      },
    ],
  },
  {
    type: 'prompt',
    name: '️ 背景',
    tags: [
      {
        name: '场所',
        tips: ['城市', '乡村', '城堡', '游乐园'],
      },
      {
        name: '天气',
        tips: ['日出', '白天', '黄昏', '夜晚'],
      },
      {
        name: '氛围',
        tips: ['春节', '圣诞节', '情人节', '万圣节'],
      },
    ],
  },
  {
    type: 'prompt',
    name: '📷 镜头',
    tags: [
      {
        name: '景别',
        tips: ['特写镜头', '中景镜头', '上半身', '半身像'],
      },
      {
        name: '角度',
        tips: ['正面视角', '侧面视角', '后背视角', '俯视'],
      },
    ],
  },
];

export const PROMPT_TIPS = isTalkie ? PROMPT_TIPS_EN : PROMPT_TIPS_ZH;
